import React from 'react';

const Readings: React.FC = () => {
  return <div>Readings</div>;
};

export default Readings;